import React from 'react';
import { Table } from 'semantic-ui-react';

import { ROW_HEIGHT } from './constants';

const block = (width, height) => (
  <div className="dz-skeleton" style={{ width, height, display: 'inline-block' }} />
);

const SkeletonRow = () => (
  <Table.Row style={{ height: ROW_HEIGHT }}>
    <Table.Cell>
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <div className="dz-skeleton" style={{ width: 35, height: 35, borderRadius: '50%', marginRight: 12 }} />
        <div>
          <div>{block(120, 12)}</div>
          <div style={{ marginTop: 6 }}>{block(80, 10)}</div>
        </div>
      </div>
    </Table.Cell>
    <Table.Cell>{block(120, 14)}</Table.Cell>
    <Table.Cell textAlign="center">{block(16, 14)}</Table.Cell>
    <Table.Cell>{block(70, 12)}</Table.Cell>
  </Table.Row>
);

export default SkeletonRow;



/** WEBPACK FOOTER **
 ** ./src/containers/large-campaign/skeleton-row.js
 **/